<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4">
      {{ title }}
    </v-card-title>

    <v-card-text>
      <CardAutocompleteRow
        v-model="publicOrganizationParticipation.commonWork.year"
        :items="yearList"
        item-value="id"
        item-text="year"
        label="Год"
        placeholder="Выберите год"
        :no-filter="false"
        :disabled="isShowMode"
        :error-messages="errorMessages.year"
        :required="!isShowMode"
        @input="
          $v.publicOrganizationParticipation.commonWork.year.$touch()
          updatePublicOrganizationParticipation()
        "
      />

      <CardFieldRow
        v-model="publicOrganizationParticipation.organization"
        label="Наименование профессионального научного общества (общественной организации)"
        placeholder="Добавьте наименование профессионального научного общества (общественной организации)"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.organization"
        @input="
          $v.publicOrganizationParticipation.organization.$touch()
          updatePublicOrganizationParticipation()
        "
      />

      <CardFieldRow
        v-model="publicOrganizationParticipation.organizationPlace"
        label="Страна, город"
        placeholder="Добавьте страну и город"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.organizationPlace"
        @input="
          $v.publicOrganizationParticipation.organizationPlace.$touch()
          updatePublicOrganizationParticipation()
        "
      />

      <CardAutocompleteRow
        v-model="publicOrganizationParticipation.participationStatus"
        :items="currentParticipationStatusList"
        item-value="id"
        item-text="name"
        :item-disabled="item => !item.isActual"
        label="Роль в организации"
        hide-border-bottom
        placeholder="Выберите роль в организации"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.participationStatus"
        :no-filter="false"
        @input="
          $v.publicOrganizationParticipation.participationStatus.$touch()
          updatePublicOrganizationParticipation()
        "
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { PublicOrganizationParticipation } from '@/models'
import CardFieldRow from '../../ui/row/CardFieldRow'
import CardAutocompleteRow from '../../ui/row/CardAutocompleteRow'
import { setValidateMessages } from '../../../scripts/validation'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  components: { CardAutocompleteRow, CardFieldRow },
  props: {
    isShowMode: Boolean,
    selectedItem: Object,
    title: String
  },

  data: () => ({
    publicOrganizationParticipation: new PublicOrganizationParticipation(),
    organization: []
  }),

  validations() {
    return {
      publicOrganizationParticipation: {
        commonWork: {
          year: { required }
        },

        organization: { required },
        organizationPlace: { required },
        participationStatus: { required }
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['participationStatusList', 'yearList']),

    currentParticipationStatusList() {
      return this.publicOrganizationParticipation.participationStatus?.isActual === false
        ? this.participationStatusList
        : this.participationStatusList.filter(el => el.isActual)
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.publicOrganizationParticipation.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.publicOrganizationParticipation[key])
      })

      Object.keys(this.$v.publicOrganizationParticipation.commonWork.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.publicOrganizationParticipation.commonWork[key])
      })

      return allErrors
    }
  },

  methods: {
    updatePublicOrganizationParticipation() {
      this.$emit(
        'update:selected-item',
        new PublicOrganizationParticipation(this.publicOrganizationParticipation.getForAPI())
      )
      this.updateInvalid()
    },

    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.publicOrganizationParticipation = new PublicOrganizationParticipation(val.getForAPI())
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
